import axiosInstance from "../../helpers/axios";
import {
  catchHandler,
  dispatchLoading,
  elseHandler,
  dispatchToast,
} from "../../helpers/dispatch";
import { responseDataFormate } from "../../helpers/bycrypt";

export const GetSteelCoilsAPI =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getSteelCoils", true);

    axiosInstance
      .get("/stock-manager/stock", {
        params: { order: "order | desc", ...params },
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr = result?.data?.data || result?.data || [];
          dispatch({
            type: "GET_STEEL_COILS_DATA",
            payload: {
              data: dataArr,
              page: params?.page || 1,
              count: result?.data?.count || result?.data?.totalDocs || dataArr.length,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === limit);
          }
        } else {
          elseHandler(dispatch, "getSteelCoils", result);
        }

        dispatchLoading(dispatch, "getSteelCoils", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getSteelCoils")(err);
      });
  };

export const GetSteelCoilByIdAPI =
  (id: string, cb?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getSteelCoilById", true);

    // We can fetch individual stock using the standard detail endpoint if there is one,
    // or just fetch by passing id as parameter. In `stockProcessManager.ts` they used `/stock-manager/stock/process` with `{ params: { id } }`
    // Wait, the API for single stock is usually `/stock-manager/stock/details` or `/stock-manager/stock`
    // Let's use `/stock-manager/stock` with `search` or `id`? Let's check how we get a single stock.
    // I'll try calling `/stock-manager/stock` with `{ params: { id } }`. If there is a `/details` endpoint, I'll use that.
    axiosInstance
      .get("/stock-manager/stock", { params: { id } })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const itemArray = result?.data?.data || result?.data;
          const item = Array.isArray(itemArray) ? itemArray[0] : itemArray || {};
          dispatch({
            type: "GET_STEEL_COIL_DETAILS",
            payload: item,
          });
          if (cb) cb(item);
        } else {
          elseHandler(dispatch, "getSteelCoilById", result);
        }

        dispatchLoading(dispatch, "getSteelCoilById", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getSteelCoilById")(err);
      });
  };

const initialState = {
  SteelCoilsList: [] as any[],
  SteelCoilsCount: 0,
  SteelCoilDetails: null as any,
};

export const steelCoilManagerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "GET_STEEL_COILS_DATA":
      return {
        ...state,
        SteelCoilsList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.SteelCoilsList, ...action.payload.data],
        SteelCoilsCount: action.payload.count,
      };
    case "GET_STEEL_COIL_DETAILS":
      return {
        ...state,
        SteelCoilDetails: action.payload,
      };
    case "UPDATE_STEEL_COIL_STOCK":
      return {
        ...state,
        SteelCoilsList: state.SteelCoilsList.map((coil: any) =>
          coil._id === action.payload.id
            ? { ...coil, qty: { ...coil.qty, current_qty: action.payload.newStockQty } }
            : coil
        ),
        SteelCoilDetails:
          state.SteelCoilDetails?._id === action.payload.id
            ? {
                ...state.SteelCoilDetails,
                qty: { ...state.SteelCoilDetails.qty, current_qty: action.payload.newStockQty },
              }
            : state.SteelCoilDetails,
      };
    case "CLEAR_STEEL_COIL_STATE":
      return initialState;
    default:
      return state;
  }
};
